import {NgModule} from '@angular/core';

import {HideFabDirective} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the HideFabModule
 * @class
 */
@NgModule({
  declarations: [HideFabDirective],
  exports: [HideFabDirective],
  imports: [IonicModule],
  providers: [],
})
export class HideFabModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/hide-fab/hide-fab.module.ts